import { render, staticRenderFns } from "./PluginIcon.vue?vue&type=template&id=b81f85c0&"
import script from "./PluginIcon.vue?vue&type=script&lang=js&"
export * from "./PluginIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports